export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER'
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS'
export const SET_REVIEW_STATUS = 'SET_REVIEW_STATUS'
export const SET_PENDING_ORDERS_COUNT = 'SET_PENDING_ORDERS_COUNT'
export const SET_CURRENT_PRODUCT_PLACES = 'SET_CURRENT_PRODUCT_PLACES'
